import logo from "./logo.svg";
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Products from "./Products";
import ProductForm from "./ProductForm";
import SignInSide from "./SignInSide";
import Contact from "./Contact";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Products />} />
        <Route path="/product" element={<ProductForm />} />
        <Route path="/product/:id" element={<ProductForm />} />
        <Route path="/signin" element={<SignInSide />} />
        <Route path="/contact" element={<Contact />} />
        {/* You can add more routes here */}
      </Routes>
    </Router>
  );
  // return <Blog />;
}

export default App;
